import base64Encode from '../../../../../utils/base64-encode';

const getAssetsToUpdate = (initialAssets, currentAssets) => {
  const initialAssetSources = initialAssets.map((asset) => asset.source);
  const currentAssetSources = new Set(currentAssets.map((asset) => asset.source));
  const sourcesWhichMayBeUpdated = new Set(
    initialAssetSources.filter((source) => currentAssetSources.has(source))
  );
  const initialAssetsMap = {};
  initialAssets.forEach((asset) => {
    initialAssetsMap[asset.id] = asset;
  });
  return currentAssets
    .filter((asset) => sourcesWhichMayBeUpdated.has(asset.source) && Boolean(asset.html))
    .filter((asset) => {
      const initialAsset = initialAssetsMap[asset.id];
      return initialAsset && initialAsset.html !== asset.html;
    })
    .map((asset) => ({ source: asset.source, content: base64Encode(asset.html) }));
};

export default getAssetsToUpdate;
